export default "__VITE_ASSET__2NNYgFgH__"